module.exports = __webpack_public_path__ + "img/square_ilustra.8f075342.png";